
import { Component, Inject } from '@angular/core';

import { PlayerTotalViewComponent } from '../player/player-total-view/player-total-view.component';
import { MAT_DIALOG_DATA,  MatDialogModule,  MatDialogRef } from '@angular/material/dialog';
import { ReportViewDialogComponent } from '../report-view-dialog/report-view-dialog.component';
import { ScoutingFlowService } from '../services/scouting-flow.service';
import { PlayerReportViewComponent } from '../player/player-report-view/player-report-view.component';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-player-view-dialog',
    imports: [PlayerReportViewComponent, MatDialogModule, MatButtonModule],
    templateUrl: './player-view-dialog.component.html',
    styleUrl: './player-view-dialog.component.css'
})
export class PlayerViewDialogComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<PlayerViewDialogComponent>){}


  close() {
    this.dialogRef.close();
  }
}
